<form (submit)="onSubmit()" [formGroup]="form" class="form-horizontal transfer-form">
  <div class="card m-3">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="card-title">Benutzer</h3>
      <button class="btn btn-primary" [disabled]="!form.valid" type="submit">Speichern</button>
    </div>
    <div class="card-body">
      <app-form-group control="username" label="Benutzername">
        <input
          id="username"
          type="text"
          placeholder="Benutzername"
          formControlName="username"
          class="form-control">
      </app-form-group>

      <app-form-group control="enabled" label="">
        <label>
          <input
            id="enabled"
            type="checkbox"
            formControlName="enabled"> Login aktiv?
        </label>
      </app-form-group>

      <app-form-group control="ldapAds" label="">
        <label>
          <input
            id="ldapAds"
            type="checkbox"
            (change)="onAdLoginChange()"
            formControlName="ldapAds"> Login über externes Verzeichnis?
        </label>
      </app-form-group>
      <app-form-group control="password" label="Neues Passwort eingeben" *ngIf="!form.getRawValue().ldapAds">
        <input
          id="password"
          type="password"
          placeholder="Passwort"
          formControlName="password"
          class="form-control">
      </app-form-group>
    </div>
  </div>
</form>
